
import { defineComponent, reactive, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMedia } from '@/utils/useMedia'
import moment from 'moment'
import { useRouter } from 'vue-router'
import { useEvent } from '@coderhouse/common'
import { DefaultMagicKeysAliasMap } from '@vueuse/core'

export default defineComponent({
  components: {},
  props: {
    course: { type: Object, required: true }
  },
  setup(props) {
    const { t } = useI18n()
    const isDesktop = useMedia('(min-width: 1366px)')
    const isMediumDesktop = useMedia('(min-width: 768px)')
    const router = useRouter()
    const today = moment().format('YYYY-MM-DD')
    const now = moment().format('YYYY-MM-DD HH:mm')

    console.log(props.course)
    console.log(today)
    console.log(props.course.accessAvailableFrom)
    console.log(props.course.accessAvailableFrom < today)

    const content = reactive({
      icon: 'fa-calendar-check',
      title: t('home.courses.welcome-course'),
      primaryText: t('home.courses.first-class-ready'),
      secondaryText: '',
      primaryButton: {
        label: 'Empty',
        link: ''
      },
      secondaryButton: {
        label: t('home.courses.go-course'),
        link: `/cursos/${props.course.camadaId}/${props.course.slug}`
      }
    })

    const redirect = (text: string, link: string, target = '_blank', redirectChallenges?: boolean) => {
      useEvent('trackEvent', 'cta', 'mis_cursos', text)
      if (redirectChallenges) {
        router.push(link) // Redirect to mfe challenges
        return
      }
      if (link) {
        window.open(link, target)
      }
      return
    }

    onMounted(() => {
      if (props.course.percentage != 100) {
        // Up to date
        if (props.course.percentage > 0 && props.course.nextClass) {
          content.icon = 'fa-calendar'
          content.title = t('home.courses.up-to-date')
          content.primaryText = t('home.courses.next-class-date', {
            nextClassDate: moment(props.course.nextClass.startDate).format('DD/MM/YY')
          })
          content.secondaryText = ''
          content.primaryButton.label = ''
          content.primaryButton.link = ''
        }

        // Pending Homework
        if (props.course.pendingHomework?.id) {
          content.icon = 'fa-bullseye'
          content.title = t('home.courses.pending-challenge')
          content.primaryText = props.course.pendingHomework?.title
          content.secondaryText = t('home.courses.pending-challenge-deadline', {
            challengeDeadline: moment(props.course.pendingHomework.deadline).format('DD/MM/YY')
          })
          content.primaryButton.label = t('home.courses.go-challenge')
          content.primaryButton.link = './course/${props.course.pendingHomework.id}'
        }

        // Day class and after class
        const hasNextClass = props.course.nextClass?.startDate
        const hasAfterClass = props.course.afterClass?.startDate
        const nextClass = moment(props.course.nextClass?.startDate).format('YYYY-MM-DD')
        const nextClassHour = moment(props.course.nextClass?.startHour).format('YYYY-MM-DD HH:mm')
        const afterClass = moment(props.course.afterClass?.startDate).format('YYYY-MM-DD')
        const afterClassHour = moment(props.course.afterClass?.startHour).format('YYYY-MM-DD HH:mm')

        if (hasNextClass && moment(nextClass).isSame(today)) {
          // console.log('nextClass', nextClassHour)
          // console.log('afterClass', afterClassHour)
          // console.log('diff next class hora', Math.abs(moment(nextClassHour).diff(now, 'minutes')))
          // console.log('diff after class hora', Math.abs(moment(afterClassHour).diff(now, 'minutes')))

          if (Math.abs(moment(nextClassHour).diff(now, 'minutes')) <= 35) {
            // Class
            content.icon = 'fa-calendar'
            content.title = t('home.courses.class-ready')
            content.primaryText = t('home.courses.live-now')
            content.secondaryText = props.course.nextClass.classTitle
            content.primaryButton.label = t('home.courses.go-zoom')
            content.primaryButton.link = props.course.zoomLink
            console.log('class today', Math.abs(moment(nextClassHour).diff(now, 'minutes')))
          } else if (
            hasAfterClass &&
            moment(afterClass).isSame(today) &&
            Math.abs(moment(afterClassHour).diff(now, 'minutes')) <= 35
          ) {
            // After class
            content.icon = 'fa-calendar'
            content.title = t('home.courses.after-class-ready')
            content.primaryText = t('home.courses.live-now')
            content.secondaryText = props.course.afterClass.title
            content.primaryButton.label = t('home.courses.go-zoom')
            content.primaryButton.link = props.course.afterClass.zoomLink
          } else if (props.course.classRate?.endDateToRate && moment(props.course.classRate?.endDateToRate).isAfter(today)) {
            // Rate class
            content.icon = 'fa-thumbs-up'
            content.title = t('home.courses.rate-class')
            content.primaryText = props.course.classRate.titleClass
            content.secondaryText = t('home.courses.rate-class-date', {
              rateClassDate: moment(props.course.classRate.endDateToRate).format('DD/MM/YY')
            })
            content.primaryButton.label = t('home.courses.rate')
            content.primaryButton.link = props.course.classRate.typeformLink
          }
        }
      }
    })

    return { t, redirect, content, isDesktop, isMediumDesktop, today }
  }
})
